import Component from '../abstracts/Component';
import ChatUtils from '../utils/ChatUtils';
import PdpFixedBarComponent from '../components/PdpFixedBarComponent';

/**
 Chat component
 */
export default class ChatComponent extends Component {

  get SELECTORS() {
    return {
      hideStickyBarBlock: '[data-is-hide-sticky-bar="true"]',
      chatBtns: '.live-chat-personal-stylist-cta , .embeddedServiceHelpButton.livechat-button, .embeddedServiceSidebar.sidebarMinimized.modalContainer',
      chatContainer: '.modalContainer.embeddedServiceSidebar.layout-docked.sidebarMaximized .dockableContainer'
    }
  }

  get CLASSES() {
    return {
      hide: 'btn-hidden',
      liveChatRaiseClass: 'live-chat-raise'
    }
  }

  constructor() {
    super();
  }

  static manageChatButtonPosition() {
    // trigger on load
    ChatComponent.setChatButtonPosition('load');
    // trigger on resize
    $(window).resize(function () {
      ChatComponent.setChatButtonPosition('resize');
    });
    // trigger on scroll
    $(window).scroll(function () {
      ChatComponent.setChatButtonPosition('scroll');
    });
    // trigger on tablet and mobile
    $('.newsletter-bottom-bar').on('click',function(){
      setTimeout(function(){
        ChatComponent.setChatButtonPosition('resize');
      },500);
    });
  }

  static setChatButtonPosition(action) {
    // vars
    let chatButton = $('.embeddedServiceHelpButton.livechat-button .helpButton');
    let newsletterBar = $('.newsletter-bottom-bar ');

    // check scroll
    if (action === 'scroll' && newsletterBar.hasClass('d-none')) return false;
    // checks selectors
    if (chatButton.length === 0 || newsletterBar.length === 0) return false;
    // going on
    let newsletterBarHeight = (newsletterBar.hasClass('d-none')) ? 0 : newsletterBar.outerHeight(true);
    // if newsletter is hidden , return
    if (action === 'load' && newsletterBarHeight === 0) return false;
    // try
    let chatOffset = ($(window).width() > 767) ? 60 : 10;
    chatButton.css('bottom', parseInt(newsletterBarHeight + chatOffset, 10) + 'px');

    if($(window).width() > 767) {
      // let personalStylistButton = $(this.SELECTORS.personalStylistButton);
      // let stylistOffset = 115;
      // personalStylistButton.css('bottom', parseInt(newsletterBarHeight + stylistOffset, 10) + 'px');
    }
  }

  raiseChatButton(bool) {
    let ctx = this;
    
    let chatBtns = document.querySelectorAll(this.SELECTORS.chatBtns);
    if (chatBtns != null && chatBtns.length > 0 ) {
      chatBtns.forEach(function(btn){
        // show or hide
        if (bool == true ) {
          btn.classList.add(ctx.CLASSES.liveChatRaiseClass);
        } else {
          btn.classList.remove(ctx.CLASSES.liveChatRaiseClass);
        }
      });
    }
    let chatContainer = document.querySelector(ctx.SELECTORS.chatContainer);

    if (chatContainer != null ) {

      if (bool == true ) {
        chatContainer.classList.add(ctx.CLASSES.liveChatRaiseClass);
      } else {
        chatContainer.classList.remove(ctx.CLASSES.liveChatRaiseClass);
      }
    }
    
  }

  showChatButton(show) {
    // global
    let ctx = this;
    // btns
    let chatBtns = document.querySelectorAll(this.SELECTORS.chatBtns);
    if (chatBtns != null && chatBtns.length > 0 ) {
      chatBtns.forEach(function(btn){
        // show or hide
        if (show == true ) {
          btn.classList.remove(ctx.CLASSES.hide);
        } else {
          btn.classList.add(ctx.CLASSES.hide);
        }
      });
    }
  }

  bindEvents() {
    // listen to events

    // contact us button
    let liveChatButton = document.querySelector('a[data-name=live-chat]');
    // button online
    this.$on('chatButtonEnabled', (e) => {
      if (liveChatButton != null) {
        liveChatButton.classList.remove('not-available');
        liveChatButton.classList.add('available');
        var btn = document.querySelector(ChatUtils.SELECTORS.chatButton);
        liveChatButton.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          if (btn != null) {
            btn.click();
          }
        });
      }
    });
    // button offline
    this.$on('chatButtonDisabled', (e) => {
      if (liveChatButton != null) {
        liveChatButton.classList.add('not-available');
        liveChatButton.classList.remove('available');
        liveChatButton.removeEventListener('click',function(){});
      }
    });
    // pdp show buttons
    var ctx = this;
    // on show bar i hide the button
    document.addEventListener('showFixedBar', function (event) {
      ctx.raiseChatButton(true);
    }, false);
    // on hide bar i show the button
    document.addEventListener('hideFixedBar', function (event) {
      ctx.raiseChatButton(false);
    }, false);
  }

  /////
  render() {
    this.log('rendering...');
    // some events
    this.bindEvents();
    // check if new chat is enabled
    let chatEnabled = (document.querySelector('#chatEnabled') != null) ? document.querySelector('#chatEnabled').value : false;
    // if is enabled let's launch it
    if (chatEnabled == 'true') {
      // script call
      let script = ChatUtils.getValue('urlEnvironmentSF')+'/embeddedservice/5.0/esw.min.js';
      // get script and initialize chat
      this.moduleLoader.loadExternalScript(script).then(() => {
        this.log('loading...');
        let subjects = {
          chatLabelSubject: '',
          chatLabelSubjectOptionOD: 'Orders and deliveries',
          chatLabelSubjectOptionRR: 'Refunds and Returns',
          chatLabelSubjectOptionFi: 'Payment, promotions and Gift Cards',
          chatLabelSubjectOptionCS: 'Comments and Suggestions',
          chatLabelSubjectOptionPAv: 'Product information and availability',
          chatLabelSubjectOptionSt: 'Stores',
          chatLabelSubjectOptionTA: 'Technical assistance',
        }
        // if is present the config then add the PS
        if (ChatUtils.getValue('personalStylistSnapConfig')) {
          subjects = ChatUtils.addToObject(subjects,'chatLabelSubjectOptionPS','Personal Stylist',1);
        }
        if (ChatUtils.getValue('liveChatShowFidelity') == 'true') {
          subjects = ChatUtils.addToObject(subjects,'chatLabelSubjectOptionPP','Fidelity Card',4);
        }
        let options = {
          selectors: {
            chatLabelOnline: '#chatLabelOnlineNew',
            chatLabelSubjectOptionPP: '#chatLabelSubjectOptionPP',
          },
          subjects: subjects,
          ctaClasses: ['cta','cta-primary'],
          ctaClassesDefault: 'false'
        }
        // setup env
        ChatUtils.setEnvironment(options);
        // update cookie path
        ChatUtils.updatePath();
        // init the chat
        ChatUtils.initializeChat();
        // new chat modifier
        ChatUtils.runsNewChat();
      });
    }
  }
}
